export default "__VITE_ASSET__Kv8lMzY2__"